/**
 * 新标签页相关配置
 */
export default {
  configData: {
    showNewsTag: true,
    showComps: [
      'LeftNews', 'RightNews'
    ],
    LeftNews: {
      newsList: {
        type: 'df',
        params: {
          qid: '2345xxxl'
        }
      },
      ad: {
        type: 'bdwm',
        uuid: [
          'u3507526', // 大图
          'u3467356' // 小图
        ],
        show_report: 'NewTab_AdShow_Baidu',
        // type: '360',
        // uuid: ['2tHbKY'],
        // show_report: 'NewTab_AdShow_360_Right',
        // click_report: 'NewTab_AdClick_360_Right'
      }
    },
    RightNews: {
      EntNews: {
        newsList: {
          type: 'df',
          params: {
            qid: '2345error'
          },
          click_report: 'NewTab_Click_News_Right'
        },
        ad: {
          type: 'bdwm',
          uuid: ['u3512147', 'u3512148'],
          show_report: 'NewTab_AdShow_Baidu_Right',
        },
      },
      AdsChuChuang: {
        show: true
      }
    }
  },
  getCfg (cfgName) {
    let srcData = arguments[1] || this.configData;
    return srcData[cfgName] || undefined;
  }
}
